import { CELL_VALUE_INPUT, CONSUME_ARROW_KEYS } from './TextValueBar';

export default function activeElementConsumesArrowKeys(){

  

  let { activeElement } = document;
  let { tagName } = (activeElement||{});

  let inputFieldTypes = ["INPUT","TEXTAREA"];

  if( inputFieldTypes.includes(tagName) ){

    let elName = activeElement.getAttribute("name");
    let isValueDisplay = elName === CELL_VALUE_INPUT;

    if( !isValueDisplay ){
      return true;
    }

    let consumesArrowKeys = activeElement.getAttribute(CONSUME_ARROW_KEYS) === "true";

    return consumesArrowKeys;
    
  }

  return false;


}
